var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63102 17.3093V14.7537C7.63101 14.1037 8.16094 13.5755 8.81752 13.5712H11.2226C11.8823 13.5712 12.4171 14.1006 12.4171 14.7537V14.7537V17.3173C12.4169 17.8692 12.8619 18.3202 13.4192 18.3332H15.0226C16.6209 18.3332 17.9167 17.0504 17.9167 15.468V15.468V8.19803C17.9081 7.57553 17.6129 6.99096 17.115 6.6107L11.6314 2.23759C10.6708 1.47614 9.30518 1.47614 8.34452 2.23759L2.88503 6.61863C2.38523 6.99736 2.0895 7.58289 2.08334 8.20597V15.468C2.08334 17.0504 3.37907 18.3332 4.97744 18.3332H6.58081C7.15197 18.3332 7.61499 17.8748 7.61499 17.3093V17.3093",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.069596c598677c1e16852714462d7099.svg";
export { ForwardRef as ReactComponent };